export enum Apps {
  Unknown = 0,
  TPMPortal = 1,
  POS = 2,
  Donation = 3,
  Lister = 4,
  AdminPortal = 5,
  CompanyPortal = 6,
}
export enum EndOfAuctionAction {
  Unknown = 0,
  Scrap = 1,
  MoveToSalesFloor = 2,
}

export enum PostingProfileRuleType {
  Unknown = 0,
  BuyNow = 1,
  Auction = 2,
}

export enum ManifestSupplyType {
  Unknown = 0,
  DonationGoods = 1,
  Supplier = 2,
}

export enum ProductStatus {
  Unknown = 0,
  Draft,
  AIProcessing,
  PendingImages,
  ReadyForListing,
  QueuedForListing,
}
export enum Status {
  Unknown = 0,
  Draft = 1,
  Active = 2,
  Inactive = 3,
}
export enum LocationType {
  ARSB = 1,
  Custom = 2,
}
